<template>
    <div class="topcode-wechat-danger-item" @click="handle">
        <div class="top">
            <div :class="'flex-center auto-width-8 state   danger-state-'+detail.state">
                {{$DICT.getValue('UNIT_DANGER_STATE', detail.state)}}
            </div>
            <div :class="'flex-center auto-width-8 level  danger-level-'+detail.level">
                {{$DICT.getValue('UNIT_DANGER_LEVEL', detail.level)}}
            </div>
            <div class="flex-center-y time ">{{detail.createdTime}}</div>
        </div>
        <div class="body">
            <SwipeCell :right-width="60">
                <div class="content">
                    <div class="flex-center-y left">
                        <img :src="imageUrl"/>
                        <div class="name" style="font-size: 14px">
                            <div>{{detail.content}}</div>
                            <div>{{detail.remark}}</div>
                        </div>
                    </div>
                    <div class="flex-center right" v-if="canHandle">
                        <span>处理</span>
                        <van-icon name="arrow"/>
                    </div>
                </div>
                <template #right>
                    <Button type="danger" style="height: 100%"
                            @click="$emit('delete',detail.id)">
                        删除
                    </Button>
                </template>
            </SwipeCell>
            <CellGroup v-if="'HANDLE'===detail.state">
                <Cell value-class="cell-value" title="处理用户" :value="detail.handleUserName"/>
                <Cell value-class="cell-value" title="处理备注" :value="detail.handleRemark"/>
                <Cell value-class="cell-value" title="处理时间" :value="detail.handleTime"/>
                <Cell value-class="cell-value" title="处理照片">
                    <UploadImage slot="label"
                                 style="float: right"
                                 :imageList="detail.handleFileIdList"
                    />
                </Cell>

            </CellGroup>
        </div>
    </div>
</template>

<script>
    import {downloadImg} from "@/config"
    import UploadImage from "@/components/UploadImage";
    import {Button, Cell, CellGroup, SwipeCell} from "vant"
    import {mapGetters} from 'vuex'

    export default {
        components: {
            UploadImage, Cell, CellGroup, SwipeCell, Button
        },
        props: {
            detail: {type: Object, default: {}}
        },
        data() {
            return {};
        },
        computed: {
            ...mapGetters({permissions: 'global/permissions'}),
            canHandle() {
                // && this.permissions.includes('SAFETY_DANGER_HANDLE')
                return 'UN_HANDLE' === this.detail.state || 'PROCESSING' === this.detail.state
            },
            imageUrl() {
                const {fileIdList} = this.detail
                if (fileIdList && fileIdList.length) {
                    return downloadImg + fileIdList[0]
                }
                return require("./images/order.png")
            },
        },
        created() {
        },
        mounted() {
        },
        methods: {
            handle() {
                this.canHandle && this.$router.push('/danger/submit/' + this.detail.id)
            }
        },
        watch: {}
    };
</script>
<style lang="less" scoped>


    .topcode-wechat-danger-item {
        width: 100%;
        padding-bottom: 3px;
        margin-bottom: 8px;
        border-radius: 8px;

        & > .top {
            color: #fff;
            display: flex;
            height: 28px;
            border-radius: 8px 8px 0px 0px;
            background: #7e7e7e;
            & > .state {
                height: 100%;
                /*width: 60px;*/
                border-radius: 8px 0px 0px 0px;
            }
            & > .level {
                height: 100%;
                /*width: 45px;*/
            }
            & > .time {
                height: 100%;
                width: 100%;
                padding-right: 5px;
                /*width: calc(100% - 115px);*/
                justify-content: flex-end;

            }
        }

        .body {
            padding-bottom: 3px;
            border: 1px #cccccc solid;
            border-radius: 0 0 8px 8px;
            display: flex;
            flex-direction: column;
            .content {
                /*padding: 2px 8px;*/
                width: 100%;
                display: flex;

                & > .right {
                    font-size: 14px;
                    font-weight: 500;
                    // color: #e89c05;
                    color: #fa7d2d;
                    width: 75px;
                }
                & > .left {
                    padding: 5px;
                    display: flex;
                    width: calc(100% - 10px);
                    & > img {
                        width: 50px;
                        height: 50px;
                        border-radius: 8px;
                    }
                    & > .name {
                        padding-left: 20px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        & > div {
                            line-height: 1.5;

                        }
                    }
                }
                & > .row {
                    display: flex;
                    line-height: 1.5;
                    & > label {
                        width: 75px;
                        flex-shrink: 0;
                        &::after {
                            margin-left: 2px;
                            content: '：';
                        }
                    }
                }
            }
        }

    }

</style>


